import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
type Notice = {
  name: string;
  country: string;
  minutesAgo: number;
  key: number;
};
function buildNotice(index: number): Notice {
  const person = purchaseNotifications[index % purchaseNotifications.length];
  return {
    ...person,
    minutesAgo: 1 + Math.floor(Math.random() * 9),
    key: Date.now()
  };
}
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * purchaseNotifications.length);
    let hideTimer: number;
    let showTimer: number;
    const cycle = () => {
      setNotice(buildNotice(index));
      index += 1;
      hideTimer = window.setTimeout(() => {
        setNotice(null);
        showTimer = window.setTimeout(cycle, 9000);
      }, 6000);
    };
    const initial = window.setTimeout(cycle, 7000);
    return () => {
      window.clearTimeout(initial);
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-24 left-0 z-30 w-full px-3 sm:bottom-6 sm:w-auto sm:max-w-sm sm:px-4" data-id="element-41" data-mp="1fxn0xvnyc8hh">
      <AnimatePresence data-id="element-42" data-mp="n6vazfxhcg2l">
        {notice && !dismissed ? <motion.div key={notice.key} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-start gap-3 rounded-2xl bg-white p-3.5 shadow-[0_12px_32px_rgba(5,14,28,0.18)] ring-1 ring-navy-900/10" role="status" data-id="element-43" data-mp="n97mba8qfs6o">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gogreen-500/10" data-id="element-44" data-mp="23kv344q331fa">
              <CheckCircle2Icon className="h-5 w-5 text-gogreen-600" aria-hidden="true" data-id="element-45" data-mp="2aqnt2t44vx5v" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-46" data-mp="2fphauxqgeabu">
              <p className="text-[13.5px] font-bold leading-snug text-navy-900" data-id="element-47" data-mp="2knsjj550iesh">
                {notice.name} from {notice.country}
              </p>
              <p className="text-[12.5px] leading-snug text-navy-800/70" data-id="element-48" data-mp="2pjhndko2ehul">
                just purchased Mechanics Decision Map™ · {notice.minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-full p-1.5 text-navy-900/40 transition-colors duration-150 ease-out hover:bg-navy-900/5 hover:text-navy-900" data-id="element-49" data-mp="1wv260rhgnng3">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="1e6oxkfeu43h6" />
            </button>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}